export default __webpack_public_path__ + "static/media/angle-double-left.a7cf0bbb.svg";